<script>
    import General from '@/services/General'
    import validationMessages from '@/components/validations'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import vue2Dropzone from 'vue2-dropzone'

import 'flatpickr/dist/flatpickr.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

    export default {
  name: 'modalEditHypePopUp',
  mixins: [validationMixin],
  components: {
            validationMessages,
            flatPickr,
            vueDropzone: vue2Dropzone,
        },
        props: {
            popupsData: {
                type: Object,
      default: null,
            },
    showSectionData: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Array,
      default: () => [],
    },
        },
        data() {
    const defaultStartDate = moment().format('YYYY-MM-DD')
    const defaultEndDate = moment().add(7, 'days').format('YYYY-MM-DD')

            return {
                showModal: false,
                tryingToSubmit: false,
                submitted: false,
                acceptedFileTypeErrorMessage: '',
                acceptedFileTypeError: false,
      dateRangeError: '',
      actionTextOption: [],
      isInitializing: false,
      popupTypeOptions: [
        { value: 'url', text: 'URL (External Link)' },
        { value: 'deeplink', text: 'Deep Link (App Section)' },
        { value: 'webview', text: 'Webview' },
        { value: 'participation', text: 'Participation' },
      ],
      recipientOptions: [
        { value: 'ALL', text: 'All Users' },
        { value: 'GROUP', text: 'User segment (group)' },
      ],
                popup: {
                    id: null,
        name: '',
                    title: '',
                    bottom_text: '',
        action: '',
        action_text: '',
        type: '',
                    selectedShowSection: '',
        participation_agreement_text: '',
        participation_tnc_url: '',
        recipient: 'ALL',
        group: '',
                    file: null,
      },
      existingImageUrl: '',
      additionalImagesCount: 0,
      duration: {
        start_date: defaultStartDate,
        start_time: '00:00',
        end_date: defaultEndDate,
        end_time: '23:59',
      },
      startDateConfig: {
        dateFormat: 'Y-m-d',
      },
      endDateConfig: {
        dateFormat: 'Y-m-d',
      },
      timePickerConfig: {
                    enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
                    time_24hr: true,
                    minuteIncrement: 1,
                },
                dropzoneOptions: {
                    url: '/',
                    autoProcessQueue: false,
        addRemoveLinks: false,
                    thumbnailWidth: 150,
                    thumbnailMethod: 'contain',
        maxFilesize: 1,
                    maxFiles: 1,
        acceptedFiles: 'image/jpeg,image/png',
                    dictMaxFilesExceeded: 'You can only upload one image',
        dictFileTooBig: 'Image is larger than 1MB',
        uploadMultiple: false,
      },
      csrf_token: localStorage.getItem('csrf_token'),
    }
  },
  validations() {
    return {
            popup: {
        name: { required },
        title: {
          required: requiredIf(function () {
            return this.typeIsParticipation
          }),
        },
        bottom_text: {
          required: requiredIf(function () {
            return this.typeIsParticipation
          }),
                },
                participation_agreement_text: {
          required: requiredIf(function () {
            return this.typeIsParticipation
          }),
                },
                participation_tnc_url: {
          required: requiredIf(function () {
            return this.typeIsParticipation
          }),
        },
        type: { required },
                selectedShowSection: {
                  required: requiredIf(function () {
            return this.typeIsDeeplink
          }),
        },
        file: {
          required: requiredIf(function () {
            return !this.existingImageUrl
          }),
        },
        recipient: { required },
        group: {
          required: requiredIf(function () {
            return this.popup.recipient === 'GROUP'
          }),
        },
      },
      duration: {
        start_date: { required },
        start_time: { required },
        end_date: { required },
        end_time: { required },
      },
    }
  },
  computed: {
            popupType: {
                get() {
                    return this.popup.type
                },
                set(value) {
                    this.popup.type = value
      },
            },
    typeIsParticipation() {
                return this.popupType === 'participation'
            },
    typeIsUrl() {
              return this.popupType === 'url'
            },
    typeIsWebview() {
              return this.popupType === 'webview'
            },
    typeIsDeeplink() {
              return this.popupType === 'deeplink'
    },
    hasGroupSelection() {
      return this.popup.recipient === 'GROUP'
    },
    formattedStartDateTime() {
      return this.combineDateTime(this.duration.start_date, this.duration.start_time)
    },
    formattedEndDateTime() {
      return this.combineDateTime(this.duration.end_date, this.duration.end_time)
    },
  },
  watch: {
    popupsData: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.populateFromPopup(newVal)
        }
      },
    },
    popupType() {
      if (this.isInitializing) {
        return
      }
      this.syncActionText(true)
    },
    actionTextOption(options) {
      if (this.isInitializing) {
        return
      }
      if (options.length && !this.popup.action_text) {
        this.syncActionText(true)
      }
    },
    'popup.recipient'(value) {
      if (value !== 'GROUP') {
        this.popup.group = ''
        if (this.$v?.popup?.group?.$reset) {
          this.$v.popup.group.$reset()
        }
      }
    },
  },
  created() {
    this.getActionTextOptions()
        },
        methods: {
    openPicker(refName) {
      const ref = this.$refs[refName]
      const instance = ref?.flatpickr || ref?.fp
      if (instance && typeof instance.open === 'function') {
        instance.open()
        return
      }
      const inputEl = ref?.$el?.querySelector?.('input') || ref?.$el || ref
      inputEl?.focus?.()
    },
    openStartDatePicker() {
      this.openPicker('startDatePicker')
    },
    openEndDatePicker() {
      this.openPicker('endDatePicker')
    },
    openStartTimePicker() {
      this.openPicker('startTimePicker')
    },
    openEndTimePicker() {
      this.openPicker('endTimePicker')
    },
    populateFromPopup(popup) {
      this.isInitializing = true

      this.popup = {
        id: popup?.id || null,
        name: popup?.name || '',
        title: popup?.title || '',
        bottom_text: popup?.bottom_text || '',
        action: popup?.action || '',
        action_text: popup?.action_text || '',
        type: popup?.type || '',
        selectedShowSection: popup?.show_section || '',
        participation_agreement_text: popup?.participation_agreement_text || '',
        participation_tnc_url: popup?.participation_tnc_url || '',
        recipient: popup?.recipient || 'ALL',
        group: popup?.group_id || '',
        file: null,
      }

      this.existingImageUrl = popup?.background_image || popup?.image || ''
      this.additionalImagesCount = Array.isArray(popup?.images) ? popup.images.length : 0

      const startMoment = popup?.date_from ? moment(popup.date_from) : null
      const endMoment = popup?.date_to ? moment(popup.date_to) : null

      this.duration = {
        start_date: startMoment ? startMoment.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
        start_time: startMoment ? startMoment.format('HH:mm') : '00:00',
        end_date: endMoment ? endMoment.format('YYYY-MM-DD') : moment().add(7, 'days').format('YYYY-MM-DD'),
        end_time: endMoment ? endMoment.format('HH:mm') : '23:59',
      }

      this.dateRangeError = ''
      this.acceptedFileTypeError = false
      this.acceptedFileTypeErrorMessage = ''
      this.submitted = false

      this.syncActionText(true)

      if (this.$refs.hypeDropzone) {
        this.$refs.hypeDropzone.removeAllFiles(true)
      }

      this.$nextTick(() => {
        this.isInitializing = false
        this.syncActionText()
      })
            },
            refreshPopupData() { 
      this.$emit('onRefresh')
    },
    combineDateTime(date, time) {
      if (!date || !time) {
        return ''
      }
      return moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm')
    },
    validateDateRange() {
      this.dateRangeError = ''

      const hasAllDateParts = [
        this.duration.start_date,
        this.duration.start_time,
        this.duration.end_date,
        this.duration.end_time,
      ].every(Boolean)

      if (!hasAllDateParts) {
        this.dateRangeError = 'Please choose both start and end date with time.'
        return false
      }

      if (!this.formattedStartDateTime || !this.formattedEndDateTime) {
        return false
      }

      if (moment(this.formattedEndDateTime).isBefore(moment(this.formattedStartDateTime))) {
        this.dateRangeError = 'End date must be after start date.'
        return false
      }

      return true
    },
    async updateHypePopUp() {
      if (this.acceptedFileTypeError) {
        return
      }

              this.tryingToSubmit = true
                this.submitted = true
                this.$v.$touch()

      const hasValidRange = this.validateDateRange()

      if (this.$v.$invalid || !hasValidRange) {
        if (process.env.NODE_ENV !== 'production') {
          const invalidFields = []

          const traverseValidationTree = (validationNode, path = []) => {
            if (!validationNode || typeof validationNode !== 'object') {
              return
            }

            if (validationNode.$params) {
              Object.keys(validationNode.$params).forEach((rule) => {
                if (validationNode.$dirty && !validationNode[rule]) {
                  const fieldPath = path.length ? path.join('.') : 'root'
                  invalidFields.push(`${fieldPath} (${rule})`)
                }
              })
            }

            Object.keys(validationNode)
              .filter((key) => !key.startsWith('$'))
              .forEach((key) => {
                traverseValidationTree(validationNode[key], [...path, key])
              })
          }

          traverseValidationTree(this.$v.popup, ['popup'])
          traverseValidationTree(this.$v.duration, ['duration'])

          if (!hasValidRange && !invalidFields.includes('duration (date_range)')) {
            invalidFields.push('duration (date_range)')
          }

          // eslint-disable-next-line no-console
          console.warn('Marketing popup update validation failed:', invalidFields)
        }

                    this.tryingToSubmit = false
        return
      }

      const formData = new FormData()
      formData.append('name', this.popup.name)
      formData.append('title', this.popup.title)
      formData.append('bottom_text', this.popup.bottom_text)

      if (this.typeIsUrl || this.typeIsWebview) {
        formData.append('action', this.popup.action)
      } else if (this.typeIsDeeplink) {
        formData.append('action', this.popup.selectedShowSection || '')
      } else {
        formData.append('action', '')
      }
      formData.append('action_text', this.popup.action_text || '')
      formData.append('type', this.popup.type)

      if (this.typeIsParticipation) {
        formData.append('participation_agreement_text', this.popup.participation_agreement_text)
        formData.append('participation_tnc_url', this.popup.participation_tnc_url)
      } else {
        formData.append('participation_agreement_text', '')
        formData.append('participation_tnc_url', '')
      }

      if (this.typeIsDeeplink) {
        formData.append('show_section', this.popup.selectedShowSection)
      } else {
        formData.append('show_section', '')
      }

      formData.append('date_from', this.formattedStartDateTime)
      formData.append('date_to', this.formattedEndDateTime)
      formData.append('recipient', this.popup.recipient)
                formData.append('csrf_token', this.csrf_token)
                formData.append('_method', 'PATCH')

      if (this.popup.file) {
                formData.append('file', this.popup.file)
      }

      if (this.hasGroupSelection) {
        formData.append('group_id', this.popup.group)
      } else {
        formData.append('group_id', '')
      }

      try {
        const response = await General.updateHypePopUp(this.popup.id, formData)
        const res = response?.data?.data ? response.data.data : false

        if (res) {
          const popupName =
            (typeof res === 'object' && res !== null && res.name) || this.popup.name || 'Popup'
          this.successmsg(`Marketing popup "${popupName}" updated!`)
          this.refreshPopupData()
          this.closeModal()
        } else {
          this.failedmsg('Failed to update marketing popup.')
        }
      } catch (error) {
        const resData = error?.response?.data?.error ? error.response.data.error : 'Failed'
        const errorMsg = Array.isArray(resData) ? resData[0] : resData
                        this.failedmsg(errorMsg)
      } finally {
                        this.tryingToSubmit = false
      }
            },
            closeModal() {
                this.showModal = false
    },
    resetProps() {
                  this.submitted = false
      this.acceptedFileTypeErrorMessage = ''
      this.acceptedFileTypeError = false
      this.dateRangeError = ''
                  this.popup.file = null
      if (this.$refs.hypeDropzone) {
        this.$refs.hypeDropzone.removeAllFiles(true)
      }
            },
    selectFile(files) {
                setTimeout(() => {
        const dropzoneFiles = this.$refs.hypeDropzone?.dropzone?.files || []
        const [file] = files
        if (!file) {
          return
        }

        if (file.size > 1048576) {
          this.acceptedFileTypeErrorMessage = 'Max file size is 1MB.'
          this.acceptedFileTypeError = true
        } else if (!['image/png', 'image/jpeg'].includes(file.type)) {
          this.acceptedFileTypeErrorMessage = 'Only PNG or JPG images are allowed.'
          this.acceptedFileTypeError = true
        } else {
          this.acceptedFileTypeErrorMessage = ''
          this.acceptedFileTypeError = false
        }

        if (dropzoneFiles.length > 1) {
          dropzoneFiles.forEach((value, index) => {
            if (index !== 0) {
              this.$refs.hypeDropzone.removeFile(value)
            }
          })
        }

        this.popup.file = !this.acceptedFileTypeError ? dropzoneFiles[0] : null

        if (this.popup.file) {
          this.existingImageUrl = ''
        }
      }, 200)
    },
    removeImage() {
      if (this.$refs.hypeDropzone) {
        this.$refs.hypeDropzone.removeAllFiles(true)
      }
      this.popup.file = null
      if (!this.existingImageUrl && this.popupsData?.background_image) {
        this.existingImageUrl = this.popupsData.background_image
      }
    },
    getActionTextOptions() {
                General.getactionTextOptions()
                    .then((response) => {
                        this.actionTextOption = response.data.data ? response.data.data : []
          this.syncActionText(true)
                    })
        .catch(() => {
                        this.actionTextOption = []
                    })
    },
    syncActionText(forceOverride = false) {
      if (!this.actionTextOption.length) {
        return
      }

      const defaultOption = this.actionTextOption[0]
      const participationOption = this.actionTextOption[2] || defaultOption
      const deeplinkOption = this.actionTextOption[1] || defaultOption

      if (!forceOverride && this.popup.action_text) {
        return
      }

      if (this.typeIsParticipation) {
        this.popup.action_text = participationOption
      } else if (this.typeIsDeeplink) {
        this.popup.action_text = deeplinkOption
      } else {
        this.popup.action_text = defaultOption
      }
    },
  },
}
</script>

<template>
  <b-modal
    id="edit_hype_popup"
    size="xl"
    v-model="showModal"
    @shown="popupsData && populateFromPopup(popupsData)"
    @hidden="resetProps"
    hide-header
    hide-footer
    body-class="p-0"
    centered
  >
    <div class="marketing-modal">
      <header class="marketing-modal__hero">
        <h2>Edit marketing popup</h2>
        <p>Update the content and targeting of your marketing popup</p>
      </header>

      <b-form @submit.prevent="updateHypePopUp">
        <section class="marketing-card">
          <header class="marketing-card__header">
            <h3>Basic Information</h3>
            <p>Essential details about your popup campaign</p>
          </header>

          <b-form-group
            label="Campaign name *"
            label-for="edit-marketing-campaign-name"
            class="mb-4"
          >
                    <b-form-input
              id="edit-marketing-campaign-name"
                            v-model.trim="popup.name"
              :class="{ 'is-invalid': submitted && $v.popup.name.$error }"
              placeholder="Enter campaign name (internal use only)"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Campaign name'"
              :validationName="$v.popup.name"
            />
                </b-form-group>

          <div class="mb-1">
            <label class="form-label d-block">Campaign duration *</label>
                </div>

          <div class="row g-3 flex-wrap">
            <div class="col-12 col-lg-6">
              <div class="marketing-datetime">
                <span class="marketing-datetime__label">From</span>
                <div class="marketing-datetime__inputs">
                  <div class="marketing-input-icon">
                    <flat-pickr
                      ref="startDatePicker"
                      v-model="duration.start_date"
                      :config="startDateConfig"
                      :class="['form-control pe-4', submitted && $v.duration.start_date.$error ? 'is-invalid' : '']"
                      placeholder="Pick date"
                    />
                    <i
                      class="uil uil-calendar-alt marketing-input-icon__icon"
                      @click="openStartDatePicker"
                    ></i>
                  </div>
                  <div class="marketing-input-icon">
                    <flat-pickr
                      ref="startTimePicker"
                      v-model="duration.start_time"
                      :config="timePickerConfig"
                      :class="['form-control pe-4', submitted && $v.duration.start_time.$error ? 'is-invalid' : '']"
                    />
                    <i
                      class="uil uil-clock marketing-input-icon__icon"
                      @click="openStartTimePicker"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="marketing-datetime">
                <span class="marketing-datetime__label">To</span>
                <div class="marketing-datetime__inputs">
                  <div class="marketing-input-icon">
                    <flat-pickr
                      ref="endDatePicker"
                      v-model="duration.end_date"
                      :config="endDateConfig"
                      :class="['form-control pe-4', submitted && $v.duration.end_date.$error ? 'is-invalid' : '']"
                      placeholder="Pick date"
                    />
                    <i
                      class="uil uil-calendar-alt marketing-input-icon__icon"
                      @click="openEndDatePicker"
                    ></i>
                  </div>
                  <div class="marketing-input-icon">
                    <flat-pickr
                      ref="endTimePicker"
                      v-model="duration.end_time"
                      :config="timePickerConfig"
                      :class="['form-control pe-4', submitted && $v.duration.end_time.$error ? 'is-invalid' : '']"
                    />
                    <i
                      class="uil uil-clock marketing-input-icon__icon"
                      @click="openEndTimePicker"
                    ></i>
                  </div>
                </div>
              </div>
                </div>
                </div>
          <div v-if="dateRangeError" class="text-danger mt-2">
            {{ dateRangeError }}
                </div>
        </section>

        <section class="marketing-card">
          <header class="marketing-card__header">
            <h3>Recipients</h3>
            <p>Select who will see this popup</p>
          </header>

          <b-form-group class="mb-0" label="Target audience *" label-for="edit-target-audience">
            <b-form-select
              id="edit-target-audience"
              v-model="popup.recipient"
              :options="recipientOptions"
              :class="{ 'is-invalid': submitted && $v.popup.recipient.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Target audience'"
              :validationName="$v.popup.recipient"
            />
          </b-form-group>

          <b-form-group
            v-if="hasGroupSelection"
            label="User segment *"
            label-for="edit-user-segment"
            class="mt-4 mb-0"
          >
            <b-form-select
              id="edit-user-segment"
              v-model="popup.group"
              :options="groups.map(group => ({ value: group.group_id, text: group.name }))"
              :class="{ 'is-invalid': submitted && $v.popup.group.$error }"
              placeholder="Select user segment"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'User segment'"
              :validationName="$v.popup.group"
            />
          </b-form-group>
        </section>

        <section class="marketing-card">
          <header class="marketing-card__header">
            <h3>Popup Type</h3>
            <p>Choose where the popup will redirect users</p>
          </header>

          <b-form-group label="Popup type *" class="mb-4">
            <b-form-select
              v-model="popupType"
              :options="popupTypeOptions"
              :class="{ 'is-invalid': submitted && $v.popup.type.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Popup type'"
              :validationName="$v.popup.type"
            />
          </b-form-group>

          <b-form-group
            v-if="typeIsUrl || typeIsWebview"
            label="Action URL"
            class="mb-4"
          >
            <b-form-input
              v-model.trim="popup.action"
              placeholder="https://example.com/landing"
            />
          </b-form-group>

          <b-form-group
            v-if="typeIsParticipation"
            label="Participation agreement text"
            class="mb-4"
          >
                  <b-form-input
                          v-model.trim="popup.participation_agreement_text"
              placeholder="Enter agreement text"
              :class="{ 'is-invalid': submitted && $v.popup.participation_agreement_text.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Participation agreement text'"
              :validationName="$v.popup.participation_agreement_text"
            />
          </b-form-group>

          <b-form-group
            v-if="typeIsParticipation"
            label="Participation Terms & Conditions URL"
            class="mb-4"
          >
                  <b-form-input
                          v-model.trim="popup.participation_tnc_url"
              placeholder="https://example.com/terms"
              :class="{ 'is-invalid': submitted && $v.popup.participation_tnc_url.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Participation T&C URL'"
              :validationName="$v.popup.participation_tnc_url"
            />
          </b-form-group>

          <b-form-group
            v-if="typeIsDeeplink"
            label="App section *"
            class="mb-0"
          >
            <b-form-select
              v-model="popup.selectedShowSection"
              :options="showSectionData.map(section => ({ value: section.method, text: section.description }))"
              :class="{ 'is-invalid': submitted && $v.popup.selectedShowSection.$error }"
              placeholder="Select an app section"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'App section'"
              :validationName="$v.popup.selectedShowSection"
            />
          </b-form-group>
        </section>

        <!-- <section class="marketing-card">
          <header class="marketing-card__header">
            <h3>Popup Content</h3>
            <p>Add text content for your popup</p>
          </header>

          <b-form-group class="mb-0">
            <b-form-textarea
              id="edit-popup-top-text"
              v-model.trim="popup.top_text"
              placeholder="Enter text (optional)"
              rows="2"
            />
          </b-form-group>
        </section> -->

        <section class="marketing-card">
          <header class="marketing-card__header marketing-card__header--icon">
            <i class="uil uil-image"></i>
            <div>
              <h3>Popup image</h3>
              <p>Image size: 980x1080px · Max size: 1MB · Keep CTA button clear of the safe zone.</p>
            </div>
          </header>

          <div
            v-if="existingImageUrl && !popup.file"
            class="current-image-preview mb-3"
          >
            <img :src="existingImageUrl" alt="Current popup" />
            <small class="text-muted d-block mt-2">
              Current image will remain unless you upload a new one.
            </small>
            <small v-if="additionalImagesCount" class="text-muted d-block">
              {{ additionalImagesCount }} additional image{{ additionalImagesCount === 1 ? '' : 's' }} linked to this popup.
            </small>
            </div>

          <div
            :class="[
              'marketing-upload',
              submitted && $v.popup.file.$error ? 'is-invalid' : '',
              acceptedFileTypeError ? 'has-error' : ''
            ]"
          >
            <vue-dropzone
              id="edit-hype-dropzone"
              ref="hypeDropzone"
              :options="dropzoneOptions"
              :use-custom-slot="true"
              @vdropzone-files-added="selectFile"
              no-progress-bar
            >
              <div class="marketing-upload__placeholder">
                <i class="uil uil-import"></i>
                <span>Drag and drop an image, or click to browse</span>
                <small>PNG, JPG up to 1MB</small>
                </div>
            </vue-dropzone>
                </div>

          <div class="d-flex align-items-center gap-3 mt-3" v-if="popup.file">
            <span class="text-muted small">{{ popup.file.name }}</span>
            <b-button size="sm" variant="outline-danger" @click="removeImage">Remove</b-button>
        </div>

          <validationMessages
            v-if="submitted"
            :fieldName="'Popup image'"
            :validationName="$v.popup.file"
          />
          <p v-if="acceptedFileTypeError" class="text-danger mt-2">{{ acceptedFileTypeErrorMessage }}</p>
        </section>

        <input type="hidden" name="csrf_token" v-model="csrf_token">

        <footer class="marketing-modal__footer">
          <b-button variant="outline-secondary" @click="closeModal">Cancel</b-button>
          <b-button variant="dark" type="submit" :disabled="tryingToSubmit">
            <b-spinner v-if="tryingToSubmit" small class="me-2" />
            Update popup
            </b-button>
        </footer>
      </b-form>
    </div>
    </b-modal>
</template>

<style scoped>
.marketing-modal {
  padding: 32px;
  background: #f7f8fb;
}

.marketing-modal__hero {
  margin-bottom: 24px;
}

.marketing-modal__hero h2 {
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 8px;
  color: #151a2d;
}

.marketing-modal__hero p {
  margin: 0;
  color: #5f6b7d;
  font-size: 16px;
}

.marketing-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 28px;
  margin-bottom: 24px;
  box-shadow: 0 12px 32px rgb(15 23 42 / 6%);
}

.marketing-card__header {
  margin-bottom: 24px;
}

.marketing-card__header h3 {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 600;
  color: #151a2d;
}

.marketing-card__header p {
  margin: 0;
  color: #5f6b7d;
}

.marketing-card__header--icon {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.marketing-card__header--icon i {
  font-size: 32px;
  color: #151a2d;
  line-height: 1;
}

.marketing-datetime {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.marketing-datetime__label {
  font-weight: 600;
  color: #151a2d;
}

.marketing-datetime__inputs {
  display: flex;
  gap: 12px;
  align-items: center;
}

.marketing-input-icon {
  position: relative;
  flex: 1;
}

.marketing-input-icon__icon {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #5f6b7d;
  font-size: 18px;
  cursor: pointer;
  pointer-events: auto;
}

.marketing-input-icon .form-control {
  width: 100%;
}

.marketing-datetime__inputs .form-control {
  padding: 12px 16px;
  border-radius: 12px;
  background: #f1f3f7;
  border: 1px solid transparent;
}

.marketing-datetime__inputs .form-control:focus {
  border-color: #6366f1;
  background: #ffffff;
  box-shadow: none;
}

.marketing-upload {
  border: 2px dashed #d3d8e6;
  border-radius: 16px;
  background: #f7f8fb;
  padding: 32px;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.marketing-upload.is-invalid {
  border-color: #f97373;
}

.marketing-upload.has-error {
  border-color: #f97373;
  background: #fff5f5;
}

.marketing-upload__placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #5f6b7d;
  font-size: 14px;
  text-align: center;
}

.marketing-upload__placeholder i {
  font-size: 32px;
  color: #151a2d;
}

.marketing-upload__placeholder small {
  color: #a0aec0;
}

.current-image-preview {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  background: #ffffff;
  text-align: center;
}

.current-image-preview img {
  max-width: 100%;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.marketing-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 12px;
}

@media (max-width: 767.98px) {
  .marketing-modal {
    padding: 20px;
  }

  .marketing-card {
    padding: 20px;
  }

  .marketing-datetime__inputs {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>